function header() {
  const primary_navigation_parent_item = $('ul.primary-navigation > li.menu-item');
  const search = $('.nav-search');
  const form = $('.menu-item-search');

  search.on('mouseenter', function () {
    if (window.innerWidth >= 992) {
      form.addClass('show');

      if ($('.search-header-module').length == 0) {
        setTimeout(function () { $('#search-field').focus() }, 500);
      }
    }
  });

  $('.nav-primary').on('mouseleave', function () {
    if (window.innerWidth >= 992) {
      form.removeClass('show');
    }
  });

  primary_navigation_parent_item.on('mouseenter', function () {
    if (window.innerWidth >= 992) {
      form.removeClass('show');
      if ($(this).hasClass('menu-item-has-children')) {
        $(this).addClass('open');
        $(this).find('.menu-item-link').addClass('open');
      }
    }
  });

  primary_navigation_parent_item.on('mouseleave', function () {
    if (window.innerWidth >= 992) {
      primary_navigation_parent_item
        .removeClass('open')
        .find('.menu-item-link')
        .removeClass('open');
    }
  });

  primary_navigation_parent_item.on('click', function () {
    if (window.innerWidth < 992) {
      if ($(this).hasClass('menu-item-has-children')) {
        $(this).toggleClass('open');
      }
      $('.header-navigation-primary').addClass('hidden');
    }
  });

  $('.header__mobile').on('click', function () {
    const header = $('.header');
    header.toggleClass('open_mobile');
    if (!header.hasClass('open_mobile')) {
      $('.header-navigation-primary').removeClass('hidden');
    }
  });
}

export { header }



// WEBPACK FOOTER //
// ./scripts/modules/header.js